<template>
  <div class="NewsCon">
    <div class="cont">
      <ComTitlte titleEn="NEWS" zhColor="#333333" titleZh="新闻中心"></ComTitlte>
      <div class="conBox">
        <div class="c_left wow slideInLeft">
          <img src="../../assets/img/index/newsCon_img.png" alt="NewsCon"/>
        </div>
        <div class="c_right wow slideInRight">
          <div class="new_title">
            <div class="n_lable">企业新闻</div>
            <router-link class="btn_more" to="/news">更多>></router-link>
          </div>
          <ul class="newsList">
            <router-link
                v-for="(item, index) in companyNewsList"
                :key="index"
                :to="
                splicingUrl({
                  base: '/newsDetails?id=' + item.infoId,
                  index: index - 0 + 1 + (companyPageNo - 1) * companyPageSize,
                  type: 'company',
                })
              "
            >
              <li class="newsItem">
                <div class="box_num">{{ index - 0 + 1 }}</div>
                <div class="box_text">
                  <div class="n_title">{{ item.infoName }}</div>
                  <div class="n_desc">
                    {{ item.infoContent }}
                  </div>
                </div>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";

export default {
  name: "NewsCon",
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  data() {
    return {
      companyNewsList: [],
      companyTotal: 1, // 总数
      companyPageNo: 1, // 当前页
      companyPageSize: 3, // 每页显示条数
    };
  },
  created() {
    this.getInfoManageList();
  },
  methods: {
    // 获取新闻资讯
    async getInfoManageList() {
      let _that = this;
      let res = await this.$request.getInfoManageList({
        pageNo: this.companyPageNo,
        pageSize: this.companyPageSize,
        infoColumn: "0",
      });
      res.rows.map((val) => {
        val.infoContent = _that.removeHTMLTag(val.infoContent);
      });
      this.companyNewsList = res.rows;
      this.companyTotal = res.total;
      // console.log(res);
    },
    // url拼接
    splicingUrl({base, index, type}) {
      return base + "&index=" + index + "&type=" + type;
    },
    //移除html标签
    removeHTMLTag(str) {
      str = str.replace(/(\n)/g, "");
      str = str.replace(/(\t)/g, "");
      str = str.replace(/(\r)/g, "");
      str = str.replace(/<[^>]+>|&[^>]+;/g, "");
      str = str.replace(/\s*/g, "");
      return str;
    },
  },
  components: {ComTitlte},
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
.NewsCon {
  width: 100%;
  min-width: 1180px;
  overflow: hidden;
  padding: 0 0 46px 0;

  .cont {
    width: 1180px;
    margin: 0 auto;

    .c_title {
      height: 44px;
      padding: 46px 0 0 0;
      position: relative;

      .t_es {
        font-size: 36px;
        font-weight: bold;
        color: #444444;
        opacity: 0.1;
      }

      .t_zh {
        font-size: 24px;
        line-height: 24px;
        font-weight: bold;
        color: $themeColor;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }

    .conBox {
      display: flex;
      justify-content: space-between;
      padding: 20px 0 0 0;

      .c_left {
        width: 464px;
        height: 310px;

        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .c_right {
        width: 670px;

        .new_title {
          display: flex;

          .n_lable {
            width: 158px;
            height: 52px;
            line-height: 52px;
            text-align: center;
            background-color: $themeColor;
            font-size: 18px;
            color: #ffffff;
          }

          .btn_more {
            flex: 1;
            height: 52px;
            line-height: 52px;
            box-sizing: border-box;
            padding: 0 14px;
            font-size: 16px;
            color: $themeColor;
            text-align: right;
            background-color: #e9e9e9;
            cursor: pointer;
          }
        }

        .newsList {
          .newsItem {
            display: flex;
            padding: 36px 0 0 0;
            cursor: pointer;

            &:hover {
              .box_num {
                color: #ffffff;
                background-color: $themeColor;
              }

              .box_text .n_title,
              .box_text .n_desc {
                color: $themeColor;
              }
            }

            .box_num {
              flex-shrink: 0;
              width: 50px;
              height: 50px;
              line-height: 50px;
              text-align: center;
              background-color: #dcdcdc;
              transition: 0.6s;
            }

            .box_text {
              width: 610px;
              padding: 0 0 0 14px;

              .n_title {
                line-height: 30px;
                font-size: 16px;
                transition: 0.6s;
                color: #333333;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }

              .n_desc {
                line-height: 20px;
                font-size: 14px;
                transition: 0.6s;
                color: #999999;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
}
</style>
